import styled from '@emotion/styled'
import {
  space,
  color,
  typography,
  display,
  layout,
  LayoutProps,
  SpaceProps,
  ColorProps,
  TypographyProps,
  DisplayProps,
} from 'styled-system'
import { ellipsis } from 'polished'
import { theme, mq, COLORS } from 'utils'
import { Box } from './Layout'

const textFunctions = [display, space, color, typography, layout]

export interface ITextProps
  extends LayoutProps,
    SpaceProps,
    TypographyProps,
    DisplayProps,
    ColorProps {}

export const Text = styled.span<ITextProps>`
  ${textFunctions}
`

export const Label = styled.span<ITextProps>`
  font-weight: ${theme.fontWeights.semi_bold};
  font-size: ${theme.fontSizes.xxs};
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1;

  color: ${COLORS.BLUEBERRY_SODA};

  ${textFunctions}
`

const Block = styled(Box)`
  > * + * {
    margin-top: ${({ gutter }) =>
      theme.space[gutter as keyof typeof theme.space] || gutter};
  }
`

Block.defaultProps = {
  gutter: '1em',
}

export const H1 = styled.h1<ITextProps>`
  font-size: ${theme.fontSizes.xxxl};
  ${mq.from.tablet`
    font-size: ${theme.fontSizes.xxxxl};
  `}
  ${textFunctions}
`

export const H2 = styled.h2<ITextProps>`
  font-size: ${theme.fontSizes.xxl};
  ${mq.from.tablet`
    font-size: ${theme.fontSizes.xxxl};
  `}
  ${textFunctions}
`

export const H3 = styled.h3<ITextProps>`
  font-size: ${theme.fontSizes.xl};
  ${mq.from.tablet`
    font-size: ${theme.fontSizes.xxl};
  `}
  ${textFunctions}
`

export const H4 = styled.h4<ITextProps>`
  font-size: ${theme.fontSizes.l};
  ${mq.from.tablet`
    font-size: ${theme.fontSizes.xl};
  `}
  ${textFunctions}
`

export const H5 = styled.h5<ITextProps>`
  font-size: ${theme.fontSizes.m};
  ${mq.from.tablet`
    font-size: ${theme.fontSizes.l};
  `}
  ${textFunctions}
`

export const H6 = styled.h6<ITextProps>`
  font-size: ${theme.fontSizes.s};
  ${mq.from.tablet`
    font-size: ${theme.fontSizes.m};
  `}
  ${textFunctions}
`

export const Ellipsis = styled(Text)`
  ${ellipsis()}
`
